export default "__VITE_ASSET__1a03fcb4__"